import { TFunction } from 'i18next'
import * as yup from 'yup'
export const createCvSchema = (t: TFunction<'translation', undefined>) =>
    yup.object().shape({
        name: yup.string().required(t('blank-errors')),
        email: yup.string().required(t('blank-errors')),
        phone: yup.string().required(t('blank-errors')),
    })
